export const getUserToken = () => JSON.parse(localStorage.getItem("authToken"));

export const storeUserToken = (userType) =>
  localStorage.setItem("authToken", JSON.stringify(userType));

export const removeUserToken = () => localStorage.removeItem("authToken");
